// Client-side JWT payload decoding for UI purposes only (what to render/redirect to).
// This is NOT a security boundary — the backend's require_admin/require_tenant_match
// dependencies (auth_dependencies.py) are what actually enforce access; a forged claim
// here can't produce a validly-signed token without SECRET_KEY.

export function decodeJwt(token) {
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
}

export function isJwtExpired(token) {
  const payload = decodeJwt(token);
  if (!payload) return true;
  if (!payload.exp) return false;
  return Date.now() >= payload.exp * 1000;
}
